import { computed, type Ref } from 'vue';
import type { Checkout } from '@vp/common';

export const useEventImage = (event: Ref<Checkout.CheckoutEvent.CheckoutEvent | undefined>) => {
  const eventImage = computed(() => {
    const images = event.value?.images?.filter(i => i.variants && i.variants.length != 0);
    if (!images || images.length == 0) {
      return null;
    }

    const highlighted = images.find(image => image.highlighted) || images[0];
    if (!highlighted.variants) {
      return null;
    }

    const variant = highlighted.variants.find(v => v.variant == 'cover_small') || highlighted.variants.find(v => v.variant == 'cover') || highlighted.variants[0];

    return variant.src;
  });

  return computed(() => eventImage.value || event.value?.venue?.logoUrl);
};
